module.exports = __webpack_public_path__ + "static/media/ml.002e41cd.svg";